import React from "react";
import SponsorRow from "./SponsorRow";
import { useSponsors } from "../api/selectors";
import LightTheme from "../theme/LightTheme";

const SponsorBlock = () => {
  const sponsors = useSponsors();

  if (sponsors.length === 0) {
    return null;
  }

  return (
    // ID needed for sidebar navigation
    <div id="partners" className="wrapper">
      <h1 className="title">{"Today's Partners"}</h1>
      <SponsorRow level={2} />
      <SponsorRow level={1} />
      <SponsorRow level={0} />
      <style jsx>{`
        .wrapper {
          background: #fdfefe;
          padding: 55px ${LightTheme.mainContentPadding}px 0
            ${LightTheme.mainContentPadding}px;
        }
        .title {
          font-weight: bold;
          font-size: 1.5rem;
          color: #343434;
        }
      `}</style>
    </div>
  );
};
export default SponsorBlock;
